// "Sua sessão expirou" (07/10/2026) — no lugar de "Network error" em tudo.
// A guarda (utils/guardaSessaoInstalar.ts) chama este aviso quando o Cognito
// RECUSA renovar a sessão (acabou o prazo de 30 dias, acesso revogado). O botão
// sai e volta para a tela de login; o que já foi salvo não se perde.
import { useEffect, useState } from 'react';
import { Modal, Button, Typography } from 'antd';
import { signOut } from 'aws-amplify/auth';
import { aoSessaoExpirar } from '../utils/guardaSessaoInstalar';
import { AVISO_SESSAO } from '../utils/guardaSessao';

export default function AvisoSessaoExpirada() {
  const [aberto, setAberto] = useState(false);
  const [saindo, setSaindo] = useState(false);
  useEffect(() => aoSessaoExpirar(() => setAberto(true)), []);

  async function entrarDeNovo() {
    setSaindo(true);
    try { await signOut(); } catch { /* a sessão já não vale: segue limpando */ }
    try { localStorage.clear(); sessionStorage.clear(); } catch { /* segue */ }
    window.location.href = '/';
  }

  return (
    <Modal open={aberto} title={AVISO_SESSAO.titulo} closable={false} maskClosable={false} keyboard={false}
      footer={<Button type="primary" loading={saindo} onClick={entrarDeNovo}>{AVISO_SESSAO.botao}</Button>}>
      <Typography.Paragraph style={{ marginBottom: 0 }}>{AVISO_SESSAO.texto}</Typography.Paragraph>
    </Modal>
  );
}
